export class ColunasSamuFormat {

  private _label: string;
  private _prefixo: string;
  private _campo: string;
  private _width: number;

  get label(): string {
    return this._label;
  }
  set label(value: string) {
    this._label = value;
  }
  get prefixo(): string {
    return this._prefixo;
  }
  set prefixo(value: string) {
    this._prefixo = value;
  }
  get campo(): string {
    return this._campo;
  }
  set campo(value: string) {
    this._campo = value;
  }
  get width(): number {
    return this._width;
  }
  set width(value: number) {
    this._width = value;
  }

  constructor() {
    this.label = undefined;
    this.prefixo = undefined;
    this.campo = undefined;
    this.width = undefined;
  }
}




// WEBPACK FOOTER //
// ./src/app/commons/model/colunas-samu-format.ts